export enum TimeCardDisplayStatusGroupType {
  total = "Total",
  open = "Open",
  closed = "Closed",
  acknowledged = "Acknowledged",
  approved = "Approved",
  completed = "Completed",
  archived = "Archived",
  infeasible = "Infeasible"
}
